"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MixpanelIntegration", {
  enumerable: true,
  get: function () {
    return _MixpanelIntegration.MixpanelIntegration;
  }
});
Object.defineProperty(exports, "TrackedRoute", {
  enumerable: true,
  get: function () {
    return _TrackedRoute.TrackedRoute;
  }
});
Object.defineProperty(exports, "mxSuperProps", {
  enumerable: true,
  get: function () {
    return _mixpanel.mxSuperProps;
  }
});
Object.defineProperty(exports, "mxUserProps", {
  enumerable: true,
  get: function () {
    return _mixpanel.mxUserProps;
  }
});
Object.defineProperty(exports, "getEventTracker", {
  enumerable: true,
  get: function () {
    return _mixpanel.getEventTracker;
  }
});
exports.MixpanelDevProjectId = exports.MixpanelProductionProjectId = exports.MixpanelDefaultEventTitles = void 0;

var _MixpanelIntegration = require("./components/MixpanelIntegration");

var _TrackedRoute = require("./components/TrackedRoute");

var _mixpanel = require("./apis/mixpanel");

var _consts = require("./consts");

let MixpanelDefaultEventTitles;
exports.MixpanelDefaultEventTitles = MixpanelDefaultEventTitles;

(function (MixpanelDefaultEventTitles) {
  MixpanelDefaultEventTitles["PageOpen"] = "Page Open";
})(MixpanelDefaultEventTitles || (exports.MixpanelDefaultEventTitles = MixpanelDefaultEventTitles = {}));

const MixpanelProductionProjectId = _consts.MixpanelProductionProjectId;
exports.MixpanelProductionProjectId = MixpanelProductionProjectId;
const MixpanelDevProjectId = _consts.MixpanelDevProjectId;
exports.MixpanelDevProjectId = MixpanelDevProjectId;